import React from 'react';
import moment from 'moment';
import TruncatedText from '../../../../components/common/TruncatedText';
import {useDispatch} from 'react-redux';
import {setSuppressDateIndicator} from '../../../../redux/slices/timeline';

interface StartDateFlagProps {
  position: { left?: string; right?: string; top: string };
  date: string;
}

export const StartDateFlag: React.FC<StartDateFlagProps> = ({
  position,
  date
}) => {
  const dispatch = useDispatch();
  const startDate = moment(date).format('ddd, MMM DD, YYYY');

  return (
    <div
      className="absolute !cursor-default"
      style={{
        width: 1,
        left: position.left,
        height: "100%",
        backgroundColor: '#8b5cf6',
      }}
      onMouseEnter={() => dispatch(setSuppressDateIndicator(true))}
      onMouseLeave={() => dispatch(setSuppressDateIndicator(false))}
    >
      <div
        className="sticky z-[1]"
        style={{
          top: position?.top,
        }}
      >
        <TruncatedText
          text="Start"
          tooltipTitle={`Start (${startDate})`}
          className="text-xs bg-violet-50 dark:bg-[#1b2333] text-black/80 dark:text-white/80 border border-violet-500 dark:border-violet-400 whitespace-nowrap overflow-hidden text-ellipsis px-2 py-0.5 rounded-r"
          placement="bottom-start"
          as="span"
        />
      </div>
    </div>
  );
};